<style src="./ContextMeFilter.scss" lang="scss"></style>
<template>
  <section class="text-filter">
    <form @submit.prevent="sendFilter" class="rowsection">
      <span class="filtertitle">Filtro por Restrito Micro Empresa</span>
        
      <div class="filters">
        <button
          @click="toggleWithoutStrict"
          :class="{ 'cp1-button__active': filters.filterValue && filters.filterValue.includes('FALSE') }"
          class="cp1-small-button selection">
          Sem Restrição
        </button>
        <button
          @click="toggleWithStrict"
          :class="{ 'cp1-button__active': filters.filterValue && filters.filterValue.includes('TRUE') }"
          class="cp1-small-button selection">
          Com Restrição
        </button>
      </div>
    </form>
  </section>
</template>

<script>
export default {
  name: 'ContextMeFilter',
  props: {
    columnId: {
      default: null
    },
    activeOptions: {
      default: () => ([])
    }
  },
  data: () => ({
    filters: {
      filterType: 'BOOLEAN',
      filterValue: null
    }
  }),
  mounted () {
    this.filters.filterValue = this.activeOptions
  },
  methods: {
    sendFilter () {
      const filter = {
        columnId: this.columnId,
        filterType: this.filters.filterType,
        filterValue: this.filters.filterValue
      }
      this.$emit('filter-value', filter)
    },
    toggleWithoutStrict () {
      const selection = [ ...this.filters.filterValue ]
      const withoutIndexOf = selection.indexOf('FALSE')
      if (withoutIndexOf > -1) {
        selection.splice(withoutIndexOf, 1)
      } else {
        selection.push('FALSE')
      }
      if (selection.length === 0) { return }

      this.filters.filterValue = selection

      this.sendFilter()
    },
    toggleWithStrict () {
      const selection = [ ...this.filters.filterValue ]
      const withIndexOf = selection.indexOf('TRUE')
      if (withIndexOf > -1) {
        selection.splice(withIndexOf, 1)
      } else {
        selection.push('TRUE')
      }
      if (selection.length === 0) { return }

      this.filters.filterValue = selection

      this.sendFilter()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/view/item-pricing/components/context-me-filter/ContextMeFilter.vue